module.exports = __webpack_public_path__ + "img/712e78f.jpg";